module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "transition-fade",
      "mode": "out-in"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d2c0701"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/transitions/Fade.vue
// module id = 103
// module chunks = 3